import AutoclickBehaviorAbstract from "../AutoclickBehaviorAbstract";
import { intentionalInteractionCounterFn } from "../autoclick_utils";

class AutoclickBehaviorInteractionCount extends AutoclickBehaviorAbstract {
  init() {
    this._counter = intentionalInteractionCounterFn(this.getBehaviorCount());
    this.triggered = false;
  }

  onInteraction(e) {
    this.setCurrentCount(this._counter(e));

    if (!this.isCountReached() || this.triggered) return;
    this.triggered = true;

    this.delayClickthrough(this.getBehaviorDelay());
  }
}

export default AutoclickBehaviorInteractionCount;



// WEBPACK FOOTER //
// ./src/js/madlib/autoclick/behaviors/AutoclickBehaviorInteractionCount.js